import { render, staticRenderFns } from "./add_cate.vue?vue&type=template&id=0f9c7c28&scoped=true"
import script from "./add_cate.vue?vue&type=script&lang=js"
export * from "./add_cate.vue?vue&type=script&lang=js"
import style0 from "./add_cate.vue?vue&type=style&index=0&id=0f9c7c28&prod&lang=css"
import style1 from "./add_cate.vue?vue&type=style&index=1&id=0f9c7c28&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c7c28",
  null
  
)

export default component.exports